import { useEffect, useState } from "react";
import { initializeApp, getApps } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { firebaseConfig } from "../../db/firebaseMethods";
import AppContext from "../../AppContext";
import { fetchActiveProduct, pullUserData } from "../../db/firebaseMethods";
import ProfilePage from "../profilePage/profilPage";

export default function ImpersonatePage() {
  const navigate = useNavigate();
  const [secondaryUser, setSecondaryUser] = useState(null);
  const [contextValue, setContextValue] = useState(null);

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("t");
      if (!token) {
        alert("Token bulunamadı.");
        return;
      }

      try {
        const secondaryApp =
          getApps().find((a) => a.name === "impersonate") ||
          initializeApp(firebaseConfig, "impersonate");

        const auth = getAuth(secondaryApp);
        const result = await signInWithCustomToken(
          auth,
          decodeURIComponent(token)
        );
        const firebaseUser = result.user;

        // Kullanıcı verisini çek
        const userData = await pullUserData(firebaseUser.uid);
        const activeProduct = await fetchActiveProduct();

        const refreshUserData = async () => {
          const fresh = await pullUserData(firebaseUser.uid);
          setContextValue((prev) => ({
            ...prev,
            user: {
              ...fresh,
              uid: firebaseUser.uid,
              email: firebaseUser.email,
              emailVerified: firebaseUser.emailVerified,
            },
          }));
        };

        setContextValue({
          user: {
            ...userData,
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            emailVerified: firebaseUser.emailVerified,
          },
          activeProduct,
          refreshUserData,
          setCentralState: () => {},
        });

        setSecondaryUser(firebaseUser);
        window.history.replaceState({}, "", window.location.pathname);
      } catch (err) {
        alert("Giriş başarısız: " + err.message);
      }
    };
    run();
  }, []);

  if (!secondaryUser || !contextValue) {
    return <div style={{ padding: 40 }}>Giriş yapılıyor...</div>;
  }

  return (
    <div>
      {/* Admin uyarı bandı */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: "#ff5722",
          color: "white",
          padding: "8px 16px",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        ⚠️ İmpersonate Modu: {secondaryUser.email}
        <button
          onClick={() => window.close()}
          style={{
            marginLeft: 12,
            color: "white",
            background: "transparent",
            border: "1px solid white",
            cursor: "pointer",
            padding: "2px 10px",
          }}
        >
          Sekmeyi Kapat
        </button>
      </div>

      {/* ProfilePage'i sahte context ile sar */}
      <div style={{ marginTop: 48 }}>
        <AppContext.Provider value={contextValue}>
          <ProfilePage />
        </AppContext.Provider>
      </div>
    </div>
  );
}
